<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png" /> -->
    <Custom-Website />
  </div>
</template>

<script>
// @ is an alias to /src
import CustomWebsite from '@/components/customWebsite/CustomWebsite.vue'

export default {
  name: 'CustomWebsiteView',
  components: {
    'Custom-Website': CustomWebsite
  },
  data: function() {
    return {}
  },
  methods: {
    addListenerForMsgFromPlugin() {
      // const that = this
      //console.log('addListenerForMsgFromPlugin ', that)
    }
  },
  beforeMount: function() {
    this.addListenerForMsgFromPlugin()
  }
}
</script>
